export default __webpack_public_path__ + "static/media/OlivierSoria-carre.82d5b014.jpg";